

<template>
  <div class="printCSS">
    <div v-for="item in orderInfo" :key="item.id">
      <div>
        <img  class="logo" src="@/assets/images/deepseek.png" alt="">
      </div>
      <div class="title">鲸鱼甄选商城</div>
      <div class="line">
        <div class="laber">
          单据号: {{item.orderNumber}}
        </div>
        <div class="laber">
          下单时间: {{item.orderTime}}
        </div>
        <div class="laber">
          运单号: {{item.expressNo}}
        </div>
        <div class="laber">
          物流公司: {{ getCourierName(item.deliveryType) }}
        </div>
      </div>
      <div class="line-bottom">
        <div class="laber">
          商品明细
        </div>
        <el-table :data="item.orderItems">
          <el-table-column width="90" prop="productName" label="商品名称"></el-table-column>
          <el-table-column width="90" prop="skuName" label="规格名称"></el-table-column>
          <el-table-column width="40" prop="count" label="数量"></el-table-column>
          <el-table-column width="60" prop="sellPrice" label="单价"></el-table-column>
        </el-table>
        <div class="laber">
          备注：{{item.remark}}
        </div>
        <div class="laber">
          总计：{{item.orderAmount}}
        </div>
        <div class="laber">
          实付：{{item.actualAmount}}
        </div>
      </div>

      <div class="line-bottom">
        <div class="laber">
          会员折扣减少：{{item.remark}}
        </div>
        <div class="laber">
          优惠券减少：{{item.orderAmount}}
        </div>
        <div class="laber">
          积分抵扣：{{item.actualAmount}}
        </div>
      </div>

      <div class="line-bottom">
        <div class="laber">收货人信息</div>
        <div class="laber">
          收货人：{{item.recipientName}}
        </div>
        <div class="laber">
          收货人电话：{{item.recipientPhone}}
        </div>
        <div class="address">
          收货地址：{{item.expAreaDetail}}{{item.expressAddress}}
        </div>
      </div>

      <div class="line-bottom">
        <div class="laber">
          下单人：{{item.memberName}}
        </div>
        <div class="laber">
          下单人电话：{{item.memberPhone}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "printBox",
  props:{
    courierList:{
      type:Array,
      default:[]
    }
  },
  data(){
    return {
      orderInfo:[]
    }
  },

  methods:{
    init(val){
      this.orderInfo = val
    },
    getCourierName(val) {
      console.log(val, 652)
      if (val) {
        return this.courierList.find(item => item.shipperCode === val).shipperName
      } else {
        return "-"
      }

    },
  }
}
</script>

<style scoped lang="scss">
.printCSS {
  //width: 80px;

  .logo {
    width: 200px;
    height: 200px;
    border-radius: 10px;
    margin-left: 20px;
    margin-top: 50px;
  }

  .title {
    font-size: 40px;
    //margin-left: 10px;
    margin-top: 30px;
  }

  .laber {
    font-size: 14px;
    //margin-left: 10px;
    margin-top: 10px;
  }

  .line {
    border-bottom: 1px dashed  #000;
    border-top:  1px dashed  #000;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 20px;
    box-sizing: border-box;
  }

  .line-bottom {
    border-bottom: 1px dashed  #000;
    padding-bottom: 10px;
  }

  .address {
    width: 380px;
    overflow-wrap: break-word;
    font-size: 14px;
    //margin-left: 10px;
    margin-top: 10px;
  }
}
</style>
